import styled, { keyframes } from "styled-components";
import { colors, font, radius } from "../../styles/theme/tokens";

// key={stars} на Badge перезапускає анімацію, коли баланс змінюється
const pop = keyframes`
   0% { transform: scale(1); }
   40% { transform: scale(1.15); }
   100% { transform: scale(1); }
`;

export const Badge = styled.button`
   display: flex;
   align-items: center;
   gap: 6px;
   margin-left: auto;
   margin-right: 10px;
   padding: 7px 14px 7px 10px;
   border-radius: ${radius.pill};
   background: ${colors.surface};
   border: 1.5px solid ${colors.line};
   box-shadow: 0 2px 8px rgba(30, 27, 58, 0.06);
   animation: ${pop} 0.5s ease-out;
   flex-shrink: 0;
   cursor: pointer;
   transition: border-color 0.15s;

   &:hover { border-color: ${colors.amber}; }
`;

export const Count = styled.span`
   font-family: ${font.text};
   font-size: 16px;
   font-weight: 800;
   color: ${colors.ink};
   font-variant-numeric: tabular-nums;
`;
